export default __webpack_public_path__ + "static/media/Front-of-the-Malthouse.c90cfb1f.jpg";